import { ODataMap, ODataObjectMap } from '../types';
import { generateGraphQlQuery, generateGraphQlSchema } from '../utils';

const ExtendedTextHeaderMap = {
  tableName: {
    bcKey: 'Table_Name',
    type: 'string',
    required: false,
  },
  no: {
    bcKey: 'No',
    type: 'string',
    required: false,
  },
  languageCode: {
    bcKey: 'Language_Code',
    type: 'string',
    required: false,
  },
  textNo: {
    bcKey: 'Text_No',
    type: 'number',
    required: false,
  },
  allLanguageCodes: {
    bcKey: 'All_Language_Codes',
    type: 'boolean',
    required: false,
  },
  description: {
    bcKey: 'Description',
    type: 'string',
    required: false,
  },
  startingDate: {
    bcKey: 'Starting_Date',
    type: 'string',
    required: false,
  },
  endingDate: {
    bcKey: 'Ending_Date',
    type: 'string',
    required: false,
  },
  salesQuote: {
    bcKey: 'Sales_Quote',
    type: 'boolean',
    required: false,
  },
  salesBlanketOrder: {
    bcKey: 'Sales_Blanket_Order',
    type: 'boolean',
    required: false,
  },
  salesOrder: {
    bcKey: 'Sales_Order',
    type: 'boolean',
    required: false,
  },
  salesInvoice: {
    bcKey: 'Sales_Invoice',
    type: 'boolean',
    required: false,
  },
  salesReturnOrder: {
    bcKey: 'Sales_Return_Order',
    type: 'boolean',
    required: false,
  },
  salesCreditMemo: {
    bcKey: 'Sales_Credit_Memo',
    type: 'boolean',
    required: false,
  },
  reminder: {
    bcKey: 'Reminder',
    type: 'boolean',
    required: false,
  },
  financeChargeMemo: {
    bcKey: 'Finance_Charge_Memo',
    type: 'boolean',
    required: false,
  },
  prepmtSalesInvoice: {
    bcKey: 'Prepmt_Sales_Invoice',
    type: 'boolean',
    required: false,
  },
  prepmtSalesCreditMemo: {
    bcKey: 'Prepmt_Sales_Credit_Memo',
    type: 'boolean',
    required: false,
  },
  purchaseQuote: {
    bcKey: 'Purchase_Quote',
    type: 'boolean',
    required: false,
  },
  purchaseBlanketOrder: {
    bcKey: 'Purchase_Blanket_Order',
    type: 'boolean',
    required: false,
  },
  purchaseOrder: {
    bcKey: 'Purchase_Order',
    type: 'boolean',
    required: false,
  },
  purchaseInvoice: {
    bcKey: 'Purchase_Invoice',
    type: 'boolean',
    required: false,
  },
  purchaseReturnOrder: {
    bcKey: 'Purchase_Return_Order',
    type: 'boolean',
    required: false,
  },
  purchaseCreditMemo: {
    bcKey: 'Purchase_Credit_Memo',
    type: 'boolean',
    required: false,
  },
  prepmtPurchaseInvoice: {
    bcKey: 'Prepmt_Purchase_Invoice',
    type: 'boolean',
    required: false,
  },
  prepmtPurchaseCreditMemo: {
    bcKey: 'Prepmt_Purchase_Credit_Memo',
    type: 'boolean',
    required: false,
  },
  serviceQuote: {
    bcKey: 'Service_Quote',
    type: 'boolean',
    required: false,
  },
  serviceOrder: {
    bcKey: 'Service_Order',
    type: 'boolean',
    required: false,
  },
  serviceInvoice: {
    bcKey: 'Service_Invoice',
    type: 'boolean',
    required: false,
  },
  serviceCreditMemo: {
    bcKey: 'Service_Credit_Memo',
    type: 'boolean',
    required: false,
  },
} as const satisfies ODataMap;

type ExtendedTextHeader = ODataObjectMap<typeof ExtendedTextHeaderMap>;

const ExtendedTextHeaderSchema = generateGraphQlSchema('ExtendedTextHeader', ExtendedTextHeaderMap);

const ExtendedTextHeaderQuery = generateGraphQlQuery('ExtendedTextHeader', ExtendedTextHeaderMap);

export { 
  ExtendedTextHeaderSchema, 
  type ExtendedTextHeader, 
  ExtendedTextHeaderQuery, 
  ExtendedTextHeaderMap 
}; 